import React, { useEffect, useState } from "react";
import { Popover } from "@mui/material";
import { ENTRY_TOOLBAR_POPOVER_OFFSET } from "./constants";
import { noop } from "lodash";

const EntryToolbarPopover = (props) => {
    const { anchorEl, width, children, open, onClose, hideBackdrop, focusHypothesis, ...otherProps } = props;
    const [anchorOrigin, setAnchorOrigin] = useState({
			vertical: "top",
			horizontal: "right",
    });
    const [transformOrigin, setTransformOrigin] = useState({
        vertical: "top",
        horizontal: "left",
    });
    const totalWidth = width + ENTRY_TOOLBAR_POPOVER_OFFSET;

    const handleClose = (e) => {
        anchorEl.style.zIndex = "";

        onClose(e);
    }

    useEffect(() => {
        if (anchorEl && focusHypothesis && open) {
            // as backdrop's zIndex is 1300;
            // to focus the entry we need to assign zIndex higher than 1300
            anchorEl.style.zIndex = 1501;
        }

        return () => {
            if (anchorEl) {
                anchorEl.style.zIndex = "";
            }
        }
    }, [open, focusHypothesis, anchorEl])

    useEffect(() => {
        if (anchorEl) {
            const { right } = anchorEl.getBoundingClientRect();

            if (window.innerWidth - right < totalWidth) {
                setAnchorOrigin({
                    vertical: "top",
                    horizontal: "left",
                });
                setTransformOrigin({
                    vertical: "top",
                    horizontal: "right",
                });
            }
        }
    }, [anchorEl]);

	return (
		<Popover
			open={open}
			anchorEl={anchorEl}
			onClose={handleClose}
			anchorOrigin={anchorOrigin}
			transformOrigin={transformOrigin}
			sx={{
				".MuiPaper-root": {
					marginLeft:
						transformOrigin.horizontal === "left"
							? `${ENTRY_TOOLBAR_POPOVER_OFFSET}px`
							: `-${ENTRY_TOOLBAR_POPOVER_OFFSET}px`,
					width,
				},
			}}
			slotProps={{
				root: {
					slotProps: {
						backdrop: {
							invisible: hideBackdrop,
						},
					},
				},
			}}
			{...otherProps}
		>
			{children}
		</Popover>
	);
};

EntryToolbarPopover.defaultProps = {
	anchorEl: null,
	width: 300,
	children: null,
	open: false,
	onClose: noop,
    hideBackdrop: true,
    focusHypothesis: false,
};

export default EntryToolbarPopover;
